import type { ReactNode } from 'react';

export const symbol_password_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M151.76-454Q105-454 72.5-486.74 40-519.47 40-566.24 40-613 72.74-645.5q32.73-32.5 79.5-32.5 46.76 0 79.26 32.74 32.5 32.73 32.5 79.5 0 46.76-32.74 79.26-32.73 32.5-79.5 32.5ZM110-200q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-260 110-260h740q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H110Zm290.5-287.38Q368-519.75 368-566q0-47.08 32.74-80.04Q433.47-679 480.24-679q46.76 0 79.26 32.96Q592-613.08 592-566q0 46.25-32.74 78.62Q526.53-455 479.76-455q-46.76 0-79.26-32.38Zm328 0Q696-519.75 696-566q0-47.08 32.74-80.04Q761.47-679 808.24-679q46.76 0 79.26 32.96Q920-613.08 920-566q0 46.25-32.74 78.62Q854.53-455 807.76-455q-46.76 0-79.26-32.38Z"
		/>
	</svg>
);
